import React from 'react';
import PropTypes from 'prop-types';

const FormTableHelp = React.memo(({ items }) => {
  const helpList = [];

  items.forEach((field, index) => {
    if (field.helpText) {
      helpList.push(
        <li key={`help-item-${index}`}>
          <strong>{field.label}</strong> - {field.helpText}
        </li>
      );
    }
  });

  if (!helpList.length) {
    return null;
  }

  return (
    <div className="table-help help-block">
      <div className="legend">Legend</div>
      <ul>{helpList}</ul>
    </div>
  );
});

FormTableHelp.propTypes = {
  items: PropTypes.array,
};

FormTableHelp.defaultProps = {
  items: [],
};

export default FormTableHelp;
